import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ngHelper } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-input-loader-wrap',
  templateUrl: './ui-input-loader-wrap.component.html',
  styleUrls: ['./ui-input-loader-wrap.component.scss'],
})
export class UiInputLoaderWrapComponent implements OnChanges {
  @Input() loading: Promise<any>;
  @Input() showLoading: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'loading', (loading) => {
      this.showLoading = true;

      loading.finally(() => this.showLoading = false);
    });
  }
}
